import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "tmp_store_cart";

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(cart)); }, [cart]);

  const add = (m, qty = 1) => {
    setCart((prev) => {
      const ex = prev.find((p) => p.id === m.id);
      if (ex) return prev.map((p) => (p.id === m.id ? { ...p, qty: p.qty + qty } : p));
      return [...prev, { id: m.id, name: m.name, price: m.mrp, qty, unit_label: m.unit_label || "Strip" }];
    });
    toast.success(`${m.name} — ${qty} × ${m.unit_label || "Strip"} cart mein add ho gaya`);
  };
  const setQty = (id, qty) =>
    setCart((prev) => (qty <= 0 ? prev.filter((p) => p.id !== id) : prev.map((p) => (p.id === id ? { ...p, qty } : p))));
  const remove = (id) => setCart((prev) => prev.filter((p) => p.id !== id));
  const clear = () => setCart([]);
  const count = cart.reduce((s, p) => s + p.qty, 0);
  const total = cart.reduce((s, p) => s + p.qty * p.price, 0);

  return <CartContext.Provider value={{ cart, add, setQty, remove, clear, count, total }}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
